export default {
	title: "Cierre de Ritual",
	closeRitual: "Cerrar Ritual",
	closingDate: "Fecha de cierre",
	closingTime: "Hora de cierre",
	closingConfirm: "¿Confirma el cierre de este ritual? Esta acción no se puede deshacer.",
	noTickets: "Ninguna ficha registrada en este ritual",
	sections: {
		messages: "Mensajes",
		return: "Retorno",
	},
	addMessage: "Agregar mensaje",
	noMessages: "Ningún mensaje agregado",
	returnType: {
		NEXT_RITUAL: "Próximo Ritual",
		SPECIFIC_RITUAL: "Ritual Específico",
		SPECIFIC_CARD: "Ficha Específica",
	},
	returnFields: {
		returnType: "Tipo de Retorno",
		selectRitual: "Seleccione el ritual",
		selectAttendanceType: "Tipo de ficha",
		quantity: "Cantidad",
		indefinite: "Indefinido",
		notes: "Observaciones",
	},
	quickClose: {
		confirm: "¿Confirma el cierre de este ritual? Esta acción no se puede deshacer.",
	},
	messages: {
		closed: "Ritual cerrado con éxito",
		closeError: "Error al cerrar el ritual",
		alreadyClosed: "Este ritual ya está cerrado",
	},
	summary: {
		messagesLabel: "mensajes",
		returnsLabel: "retornos",
	},
	pendingReturns: "Retornos pendientes",
	expandAll: "Expandir todos",
	collapseAll: "Colapsar todos",
};
